export const calculateHoursBetween = (startTime: string, endTime: string) => {
  const parseTime = (time: string): Date => {
    if (time.includes("T")) {
      return new Date(time);
    } else {
      const [hours, minutes, seconds] = time.split(":").map(Number);
      const date = new Date();
      date.setHours(hours, minutes, seconds || 0, 0);
      return date;
    }
  };

  const startDate = parseTime(startTime);
  const endDate = parseTime(endTime);

  const diffHours = Math.round(
    (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60)
  );

  return diffHours ? diffHours : 0;
};
